/**
 * LoginWorldCanvas
 * Phaser-based world renderer for login screen background
 * Renders procedurally generated world with islands and ambient NPCs
 */

import React, { useEffect, useRef } from 'react';
import Phaser from 'phaser';
import { LoginWorldScene } from '../game/scenes/LoginWorldScene';

interface LoginWorldCanvasProps {
  width: number;
  height: number;
}

export const LoginWorldCanvas: React.FC<LoginWorldCanvasProps> = ({ width, height }) => {
  const gameRef = useRef<Phaser.Game | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const config: Phaser.Types.Core.GameConfig = {
      type: Phaser.AUTO,
      width,
      height,
      parent: containerRef.current,
      backgroundColor: '#0a1428',
      render: {
        pixelArt: true,
        antialias: false,
      },
      scene: [LoginWorldScene],
      physics: {
        default: 'arcade',
        arcade: {
          debug: false,
        },
      },
    };

    gameRef.current = new Phaser.Game(config);

    return () => {
      if (gameRef.current) {
        gameRef.current.destroy(true);
        gameRef.current = null;
      }
    };
  }, [width, height]);

  return (
    <div
      ref={containerRef}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width,
        height,
        zIndex: 1,
        pointerEvents: 'none',
      }}
    />
  );
};
